module.exports = __webpack_public_path__ + "static/media/circleBackground.6bad7a26.png";